import { View } from "react-native";
import { backgroundColorStyles, borderStyles } from "../../../../styles/design-system";

const AccordionShell = ({ children }) => {
  return (
    <View
      style={[
        backgroundColorStyles.bgWhite,
        borderStyles.borderMuted,
        {
          borderRadius: 16,
          overflow: "visible",
          position: "relative",
        },
      ]}>
      {children}
    </View>
  );
};

export default AccordionShell;
